import { Badge, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTableTranslation } from '../translation';

import * as S from './style';

function SecondHead({ table, components, globalFilters, onFilterChange }) {
  const translation = useTableTranslation();
  const { t } = useTranslation();

  if (components?.SecondHead) {
    return (
      <components.SecondHead
        table={table}
        globalFilters={globalFilters}
        onFilterChange={onFilterChange}
      />
    );
  }

  return (
    !!globalFilters?.filters?.length && (
      <S.SubtitleWrapper>
        <Typography variant="caption1">{`${t(translation.filteredWithText)}:`}</Typography>
        {globalFilters.filters?.map(filter => (
          <Badge
            color="bgDefault"
            variant="contained"
            key={filter.value}
            size="sm"
            rounded
            closable
            onClose={() => {
              onFilterChange(globalFilters.filters.filter(f => f.value !== filter.value));
            }}
          >
            {filter.label}
          </Badge>
        ))}
      </S.SubtitleWrapper>
    )
  );
}

export { SecondHead };
